let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1D2zq")).then(() => parcelRequire('1vqLd'));